/* Aurah — variant availability.
   Frame & Finish drives Size: only sizes that exist for the chosen finish are shown
   (e.g. Stretched Canvas only offers sizes that fit the painting's shape). If the
   current size doesn't exist for the new finish, the nearest available size is
   selected so the form never points at a combination that isn't for sale.
   Also keeps the add-to-cart button in step with the variant's availability. */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  var form = document.querySelector('[data-product-form]');
  if (!form) return;
  var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  if (!handle) return;

  var product = null;
  var submitBtn = form.querySelector('[data-product-submit]');
  if (submitBtn && !submitBtn.disabled) submitBtn.setAttribute('data-label-add', submitBtn.textContent.trim());
  function optName(o) { return typeof o === 'string' ? o : o.name; }
  function radios(name) {
    return Array.prototype.slice.call(form.querySelectorAll('input[type="radio"]'))
      .filter(function (r) { return r.name === 'options[' + name + ']'; });
  }
  function selected() {
    var out = {};
    Array.prototype.forEach.call(form.querySelectorAll('input[type="radio"]:checked'), function (r) {
      var m = (r.name || '').match(/options\[(.+)\]/);
      if (m) out[m[1]] = r.value;
    });
    return out;
  }
  function findVariant(sel) {
    var names = product.options.map(optName);
    return product.variants.find(function (v) {
      return names.every(function (n, i) { return sel[n] === v['option' + (i + 1)]; });
    }) || null;
  }

  function refresh() {
    if (!product || !product.options || product.options.length < 2) return;
    var names = product.options.map(optName);
    var driver = names.find(function (n) { return /frame|finish/i.test(n); }) || names[names.length - 1];
    var sel = selected();
    names.forEach(function (n) {
      if (n === driver) return;
      var list = radios(n), firstOk = null, currentOk = false;
      list.forEach(function (r) {
        var trial = Object.assign({}, sel); trial[n] = r.value;
        var ok = !!findVariant(trial);
        var lbl = r.closest('.variant-swatch');
        if (lbl) lbl.style.display = ok ? '' : 'none';
        if (ok && !firstOk) firstOk = r;
        if (ok && r.checked) currentOk = true;
      });
      if (!currentOk && firstOk) {
        // pick the closest available value to what was selected (by list position)
        var cur = list.findIndex(function (r) { return r.checked; });
        var best = firstOk, bestD = 1e9;
        list.forEach(function (r, i) {
          var trial = Object.assign({}, sel); trial[n] = r.value;
          if (findVariant(trial) && Math.abs(i - cur) < bestD) { best = r; bestD = Math.abs(i - cur); }
        });
        list.forEach(function (r) {
          var l = r.closest('.variant-swatch'); if (l) l.classList.toggle('is-active', r === best);
        });
        best.checked = true;
        best.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    var v = findVariant(selected());
    var btn = form.querySelector('[data-product-submit]');
    if (btn && v) {
      btn.disabled = !v.available;
      var icon = btn.querySelector('svg');
      var label = v.available ? (btn.getAttribute('data-label-add') || 'Add to cart') : 'Sold out';
      btn.textContent = ' ' + label;
      if (icon) btn.insertBefore(icon, btn.firstChild);
    }
  }

  fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) { product = p; refresh(); })
    .catch(function () {});

  form.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') refresh();
  });
})();
